<div class="du-chat-header">
    <span class="d-flex align-items-center">
        <mat-icon *ngIf="userflag" class="du-arrow-back-click" (click)="arrowBackfunc()">arrow_back</mat-icon>
        
        <div class="du-chat-avatar-wrapper">
            <img [src]="currentUser?.gender != 'F' ? 'assets/man.png' : 'assets/women.png'" alt="Avatar" class="du-chat-avatar">
            <span class="du-chat-status-dot-home online" [class.offline]="currentUser?.online == false"></span>
        </div>
        
        <span><strong>{{ currentUser?.usr_display_nm }}</strong></span>
    </span>
</div>